import { render } from "./SideNavInput.vue?vue&type=template&id=4dbc8ec8"
import script from "./SideNavInput.vue?vue&type=script&lang=js"
export * from "./SideNavInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Development/lotte-deploy/cms-prod-lodash-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__